import React, { FC } from 'react';

import { Theme } from '@constants';

import { styles } from './styles';

import { TWCText } from '../../primitives/TWCText/TWCText';

export const TWCTileButtonContent: FC<TWCTileButtonContentProps> = ({ children, title = '' }) => (
  <>
    {children}
    <TWCText noTestID style={[Theme.styles.headerText, styles.buttonText]}>
      {title}
    </TWCText>
  </>
);

type TWCTileButtonContentProps = {
  title?: string;
};
